module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Login"
    }
  }, [_c('AuthContainer', [_c('section', {
    staticClass: "mt-4 box"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Login")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login()
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: _vm.error && 'is-danger',
    attrs: {
      "type": "email",
      "placeholder": "name@example.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    class: _vm.error && 'is-danger',
    attrs: {
      "type": "password",
      "placeholder": "super secret password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control flex-space-between flex-align-center"
  }, [_c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.loading
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/forgot-password"
    }
  }, [_vm._v("Forgot password?")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-2 mt-1"
  }, [_c('span', {
    staticClass: "or-bar"
  }), _vm._v(" or "), _c('span', {
    staticClass: "or-bar"
  })]), _vm._v(" "), _c('SocialButtons', {
    attrs: {
      "page": 'login',
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-4"
  }, [_vm._v("\n        Need an account? "), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Signup →")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7f87b417"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1073
// module chunks = 0